import React from 'react';
import Modal from '../../shared/Modal';

const FullImageModal = ({ isFull, imgUrl }) => {
  return (
    <Modal open={isFull} backgroundColor="none">
      <div className="full-image-container">
        <img src={imgUrl} className="full-display"></img>
      </div>
    </Modal>
  );
};

export default FullImageModal;



// WEBPACK FOOTER //
// ./src/components/Newsroom/MediaKit/FullImageModal.js